module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-9-1.jpg",
      "src": "images/img-9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "pz21-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_p1",
      "id": "bb_p1"
    }
  }, [_vm._v("PART 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct3"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_p1"
    }
  }, [_c('b', [_vm._v("LIVING IN FEAR: MY STORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz21-4"
    }
  }, [_vm._v("I want to share my story with you through the filter of my fear. My desire before I offer help, counsel, and ministry is to open up and allow you to hear my pain, my struggles, and what this battle with fear has created in my own life.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e5e2a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01.vue
// module id = 81
// module chunks = 0